import { getInitials } from "../../utils/UserInfoFormatting";

interface UserInfo {
  first_name: string;
  last_name: string;
}

interface ButtonMenuProps {
  userInfo?: UserInfo | null;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
  navbar?: boolean;
}

export default function ButtonMenu({
  userInfo,
  onClick,
  onMouseEnter,
  onMouseLeave,
  navbar = true,
}: ButtonMenuProps) {
  let accountName = "";
  let fullInitials: (string | undefined)[] | string = "";
  if (userInfo !== undefined && userInfo !== null) {
    accountName = userInfo.first_name + " " + userInfo.last_name;
    fullInitials = getInitials(accountName);
  } else {
    accountName = "Test User";
    fullInitials = "Test U.";
  }

  return (
    <button
      className="userinfo-wrapper flex p-2 w-full h-fit items-center gap-3 border-none bg-transparent text-white hover:text-white"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={`bg-[#0E98D0] rounded-full ${navbar ? "h-[32px] w-[32px]" : "h-[40px] w-[40px]"} flex-shrink-0 flex justify-center items-center text-sm font-bold border-none text-white`}
      >
        {fullInitials.length > 0 ? <span>{fullInitials[0]}</span> : null}
      </div>
      <p className="m-0 text-sm truncate">
        {fullInitials.length > 0 ? (
          <span>
            {fullInitials[1]} {fullInitials[2]}.
          </span>
        ) : null}
      </p>
    </button>
  );
}
